export default __webpack_public_path__ + "1fc76eda1f7e68c7b85ce473cbfe5bb6.jpg";